import { styled } from '@mui/material/styles';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 'calc(100% - 32px)',
        height: 'calc(var(--100vh) - 32px)',
        '@media (max-width: 600px)': {
            height: 'var(--100vh)',
            width: '100%',
        },
    },
    '& .modal-base-content': {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        '@media (max-width: 768px)': {
            gridTemplateColumns: '100%',
        },
    },
});

export const FormWrapper = styled('div')({
    padding: '24px 16px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'initial',
    '@media (max-width: 768px)': {
        overflowY: 'initial',
    },
});

export const PreviewWrapper = styled('div')({
    backgroundColor: '#f2f2f2',
    overflowY: 'auto',
    padding: '24px 0',
    '@media (max-width: 768px)': {
        overflowY: 'initial',
    },
    '@media (max-width: 420px)': {
        padding: '24px 16px',
    },
});

export const RadioButtonsWrapper = styled('div')({
    overflowX: 'auto',
    height: 32,
    marginBottom: 24,
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    '@media (max-width: 768px)': {
        overflowX: 'auto',
    },
});

export const RadioButtons = styled(RadioButtonsGroup)({
    width: 505,
    display: 'block',
    '& .MuiFormControlLabel-root': {
        height: 32,
        padding: '0 4px',
        flexBasis: 'auto',
    },
});

export const TwoColumnsForm = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
    gridGap: 16,
    margin: '8px 0',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gridGap: 0,
    },
});
